import { useIsMobile } from 'hooks/useIsResponsive'
import useSidebarStore from 'store/useSidebar'
import useDocumentsManagementStore from 'store/useDocumentsManagementStore'
import RenderImage, {
  FileExtension,
  downloadBase64File,
  mountTextUserDate,
  renderDefaultIcon
} from 'utils/fileFunction'
import ContainerImage from 'components/Custom/ContainerImages'
import { TitleText } from 'components/Custom/Typographies'
import { CustomPdfViewer, FilledButton, SidebarBox, SidebarFooter } from 'components/Custom'
import { Box } from 'components/Material'

export const DocumentApprovalViewer = ({ sidbarToReturn = '' }) => {
  const { openSidebar } = useSidebarStore((state) => state)
  const { documentToDownload } = useDocumentsManagementStore((state) => state)
  const isMobile = useIsMobile()
  const { nm_tipo_arquivo, doc_digitalizado, nm_arquivo, nm_usuario_inclusao, dh_inclusao } =
    documentToDownload
  const tipoArquivo = nm_tipo_arquivo.replace('.', '')
  const fileTypeLowerCase = tipoArquivo.toLowerCase()

  return (
    <ContainerImage
      isPageLoading={!documentToDownload}
      leftText={documentToDownload.nm_arquivo}
      onRightIconClick={() => openSidebar(sidbarToReturn)}
    >
      <SidebarBox className="pt-5">
        <TitleText
          align="center"
          text={mountTextUserDate(nm_usuario_inclusao, dh_inclusao)}
          typeStyle="small"
        />
      </SidebarBox>
      <Box className="w-full flex flex-col items-center justify-center p-5 flex-grow">
        <Box className="w-full items-center flex justify-center">
          {fileTypeLowerCase === 'pdf' && (
            <Box className="w-full max-w-[800px] overflow-scroll max-h-[calc(100vh-248px)]">
              <CustomPdfViewer file={doc_digitalizado?.documento} disableScroll={true} />
            </Box>
          )}
          {(fileTypeLowerCase === 'png' ||
            fileTypeLowerCase === 'jpg' ||
            fileTypeLowerCase === 'jpeg') && (
            <RenderImage
              base64Data={doc_digitalizado?.documento}
              type={fileTypeLowerCase}
              isMobile={isMobile}
            />
          )}
          {fileTypeLowerCase !== 'pdf' &&
            fileTypeLowerCase !== 'png' &&
            fileTypeLowerCase !== 'jpg' &&
            fileTypeLowerCase !== 'jpeg' &&
            renderDefaultIcon(isMobile)}
        </Box>
      </Box>
      <SidebarFooter className={`w-full  ${isMobile ? ' bg-[#f4f4f6]' : 'bg-[#000]'} `}>
        <FilledButton
          onClick={() =>
            downloadBase64File({
              file: doc_digitalizado?.documento,
              extension: fileTypeLowerCase as FileExtension,
              name: nm_arquivo
            })
          }
          disabled={!doc_digitalizado?.documento}
        >
          Download
        </FilledButton>
      </SidebarFooter>
    </ContainerImage>
  )
}
